<template>
  <div class="checkout-item-wrapper">
    <div class="mb-12 d-flex">
      <img
        :src="item.image"
        class="cart-image pa-5 rounded-lg elevation-3"
        :class="{
          'mr-8': $vuetify.breakpoint.smAndUp,
          'mr-4': !$vuetify.breakpoint.smAndUp
        }"
      />
      <div
        class="d-flex w-100"
        :class="{
          'flex-row': $vuetify.breakpoint.smAndUp,
          'flex-column': !$vuetify.breakpoint.smAndUp
        }"
      >
        <div>
          <p class="text-subtitle-1 grey--text">
            {{ item.product_subcategory }}
          </p>
          <p class="text-body secondary--text">
            {{ item.product_name }}
          </p>
          <p class="text-body secondary--text" v-if="item.volume_variation === 1">
            {{ item.product_volume_variation_name }}
          </p>
        </div>
        <div class="ml-auto">
          <p>
            <span class="text-body mr-2">{{ item.currency }} {{ item.final_price }}</span>
            <span v-if="item.discount_percentage" class="text-subtitle-1 text-decoration-line-through grey--text text--lighten-1">{{ item.currency }} {{ item.unit_price }}</span>
          </p>
          <p>{{ $t('label.qty') }}: {{ item.cart_quantity }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {}
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
.cart-image {
  width: 120px;
  height: 120px;
  object-fit: cover;

  @media only screen and (min-width: 640px) {
    width: 180px;
    height: 180px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}
</style>
